import { render, staticRenderFns } from "./NicheShow_Desktop.vue?vue&type=template&id=83e61baa&scoped=true&"
import script from "./NicheShow_Desktop.vue?vue&type=script&lang=js&"
export * from "./NicheShow_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./NicheShow_Desktop.vue?vue&type=style&index=0&id=83e61baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e61baa",
  null
  
)

export default component.exports